import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartService } from '../../../app/commons/cart-service';
import { LayoutService } from '../../../app/commons/layout-service';
import { CurrencyPipe } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mobile-cart-bar',
  standalone: true,
  imports: [CommonModule, CurrencyPipe],
  templateUrl: './mobile-cart-bar.html',
  styleUrls: ['./mobile-cart-bar.scss']
})
export class MobileCartBar {
  private cartService = inject(CartService);
  private layout = inject(LayoutService);
  private router = inject(Router);

  // read signals
  get items() {
    return this.cartService.cartItemsSignal();
  }

  // whether address dialog is open (hide mobile bar while entering address)
  get isAddressDialogOpen() {
    return this.cartService.isAddressDialogOpen();
  }

  get itemCount() {
    return this.items.reduce((s, i) => s + i.quantity, 0);
  }

  get netTotal() {
    return this.cartService.getCartItemsOriginalAndNetTotal()[1];
  }

  isMobile() {
    return this.layout.isMobile();
  }

  openCart() {
    console.debug('MobileCartBar.openCart invoked');
    if (this.isAddressDialogOpen) {
      // If address dialog is open, do nothing — prefer dialog controls
      return;
    }
    // prefer smooth scroll to the in-page cart component
    try {
      const el = typeof document !== 'undefined' ? document.getElementById('cart-component') : null;
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    } catch (e) {
      console.debug('scroll to cart failed', e);
    }

    // fallback: navigate to order page
    const ev = new CustomEvent('open-cart', { bubbles: true });
    window.dispatchEvent(ev);
    this.router.navigate(['/order']).catch(() => {
      try {
        window.location.href = '/order';
      } catch (e) {
        console.debug('fallback navigation failed', e);
      }
    });
  }
}
